import { LoyaltyProgramStatus } from '../models';

import { LoyaltyProgramProductWithPagingResult, LoyaltyStatus } from './types';

export const LOYALTY_STATUSES_MAP: Record<LoyaltyStatus, LoyaltyProgramStatus> = {
  [LoyaltyStatus.Deleted]: 'deleted',
  [LoyaltyStatus.Published]: 'published',
  [LoyaltyStatus.Review]: 'review',
  [LoyaltyStatus.Declined]: 'declined',
  [LoyaltyStatus.Archive]: 'archive',
} as const;

export const DEFAULT_ITEMS_WITH_PAGING: LoyaltyProgramProductWithPagingResult = {
  items: null,
  hasMore: false,
} as const;

/** Кол-во элементов на странице для пагинации */
export const ITEMS_PER_PAGE_BY_DEFAULT = 20;
